
export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';

export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';
export const USER_POS_INFO = 'USER_POS_INFO';
export const AUTH_MOBILE_VERIFICATION_START = 'AUTH_MOBILE_VERIFICATION_START';

export const MODULE_START = 'MODULE_START';
export const MODULE_SUCCESS = 'MODULE_SUCCESS';
export const MODULE_FAIL = 'MODULE_FAIL';

export const PROCESS_MASTERLIST_START = 'PROCESS_MASTERLIST_START';
export const PROCESS_MASTERLIST_SUCCESS = 'PROCESS_MASTERLIST_SUCCESS';
export const PROCESS_MASTERLIST_FAIL = 'PROCESS_MASTERLIST_FAIL';

export const PROCESS_MASTERDELETE_SUCCESS = 'PROCESS_MASTERDELETE_SUCCESS';
export const PROCESS_MASTERDELETE_FAIL = 'PROCESS_MASTERDELETE_FAIL';

export const PROCESS_FETCH_START = 'PROCESS_FETCH_START';
export const PROCESS_FETCH_SUCCESS = 'PROCESS_FETCH_SUCCESS';
export const PROCESS_FETCH_FAIL = 'PROCESS_FETCH_FAIL';

export const FETCH_RELAVANT_LIST_START = 'FETCH_RELAVANT_LIST_START';
export const FETCH_RELAVANT_LIST_SUCCESS = 'FETCH_RELAVANT_LIST_SUCCESS';
export const FETCH_RELAVANT_LIST_FAIL = 'FETCH_RELAVANT_LIST_FAIL';

export const FETCH_POSITION_LIST_START = 'FETCH_POSITION_LIST_START';
export const FETCH_POSITION_LIST_SUCCESS = 'FETCH_POSITION_LIST_SUCCESS';
export const FETCH_POSITION_LIST_FAIL = 'FETCH_POSITION_LIST_FAIL';

export const FETCH_KPI_LIST_START = 'FETCH_KPI_LIST_START';
export const FETCH_KPI_LIST_SUCCESS = 'FETCH_KPI_LIST_SUCCESS';
export const FETCH_KPI_LIST_FAIL = 'FETCH_KPI_LIST_FAIL';

export const FETCH_DEPARTMENT_LIST_START = 'FETCH_DEPARTMENT_LIST_START';
export const FETCH_DEPARTMENT_LIST_SUCCESS = 'FETCH_DEPARTMENT_LIST_SUCCESS';
export const FETCH_DEPARTMENT_LIST_FAIL = 'FETCH_DEPARTMENT_LIST_FAIL';

export const FETCH_KEYWORDVALUE_LIST_START = 'FETCH_KEYWORDVALUE_LIST_START';
export const FETCH_KEYWORDVALUE_LIST_SUCCESS = 'FETCH_KEYWORDVALUE_LIST_SUCCESS';
export const FETCH_KEYWORDVALUE_LIST_FAIL = 'FETCH_KEYWORDVALUE_LIST_FAIL';

export const FETCH_SAPWORKPERMIT_LIST_START = 'FETCH_SAPWORKPERMIT_LIST_START';
export const FETCH_SAPWORKPERMIT_LIST_SUCCESS = 'FETCH_SAPWORKPERMIT_LIST_SUCCESS';
export const FETCH_SAPWORKPERMIT_LIST_FAIL = 'FETCH_SAPWORKPERMIT_LIST_FAIL';

export const MENU_START = 'MENU_START';
export const MENU_SUCCESS = 'MENU_SUCCESS';
export const MENU_FAIL = 'MENU_FAIL';

export const DYNAMIC_PROCESS_START = 'DYNAMIC_PROCESS_START';
export const DYNAMIC_PROCESS_SUCCESS = 'DYNAMIC_PROCESS_SUCCESS';
export const DYNAMIC_PROCESS_FAIL = 'DYNAMIC_PROCESS_FAIL';

export const TABLE_LIST_START = 'TABLE_LIST_START';
export const TABLE_LIST_SUCCESS = 'TABLE_LIST_SUCCESS';
export const TABLE_LIST_FAIL = 'TABLE_LIST_FAIL';

export const KOT_ACTIONS_START = 'KOT_ACTIONS_START';
export const KOT_ACTIONS_SET = 'KOT_ACTIONS_SET';
export const KOT_ACTIONS_FAIL = 'KOT_ACTIONS_FAIL';
export const TABLE_COMMON_LIST_SUCCESS = 'TABLE_COMMON_LIST_SUCCESS';

export const DYNAMIC_DELETE_PROCESS_START = 'DYNAMIC_DELETE_PROCESS_START';
export const DYNAMIC_DELETE_PROCESS_SUCCESS = 'DYNAMIC_DELETE_PROCESS_SUCCESS';
export const DYNAMIC_DELETE_PROCESS_FAIL = 'DYNAMIC_DELETE_PROCESS_FAIL';

export const KEYWORD_LIST_START = 'KEYWORD_LIST_START';
export const KEYWORD_LIST_SUCCESS = 'KEYWORD_LIST_SUCCESS';
export const KEYWORD_LIST_FAIL = 'KEYWORD_LIST_FAIL';

export const USER_DETAIL_START = 'USER_DETAIL_START';
export const USER_DETAIL_SUCCESS = 'USER_DETAIL_SUCCESS';
export const USER_DETAIL_FAIL = 'USER_DETAIL_FAIL';

export const FETCH_SUBORDINATES_LIST_START = 'FETCH_SUBORDINATES_LIST_START';
export const FETCH_SUBORDINATES_LIST_SUCCESS = 'FETCH_SUBORDINATES_LIST_SUCCESS';
export const FETCH_SUBORDINATES_LIST_FAIL = 'FETCH_SUBORDINATES_LIST_FAIL';

export const FETCH_REQUEST_START = 'FETCH_REQUEST_START';
export const FETCH_REQUEST_SUCCESS = 'FETCH_REQUEST_SUCCESS';
export const FETCH_REQUEST_FAIL = 'FETCH_REQUEST_FAIL';

export const FETCH_CALENDAR_DATA_START = 'FETCH_CALENDAR_DATA_START';
export const FETCH_CALENDAR_DATA_SUCCESS = 'FETCH_CALENDAR_DATA_SUCCESS';
export const FETCH_CALENDAR_DATA_FAIL = 'FETCH_CALENDAR_DATA_FAIL';

export const FETCH_CONTAINER_START = 'FETCH_CONTAINER_START';
export const FETCH_CONTAINER_SUCCESS = 'FETCH_CONTAINER_SUCCESS';
export const FETCH_CONTAINER_FAIL = 'FETCH_CONTAINER_FAIL';


export const FETCH_SHIFT_PATTERN_START = 'FETCH_SHIFT_PATTERN_START';
export const FETCH_SHIFT_PATTERN_SUCCESS = 'FETCH_SHIFT_PATTERN_SUCCESS';
export const FETCH_SHIFT_PATTERN_FAIL = 'FETCH_SHIFT_PATTERN_FAIL';

export const FETCH_DEPENDENT_DETAILS = 'FETCH_DEPENDENT_DETAILS';
export const FETCH_QUOTA_DETAILS = 'FETCH_QUOTA_DETAILS';

export const FETCH_REQUEST_ATTRIBUTE_START = 'FETCH_REQUEST_ATTRIBUTE_START';
export const FETCH_REQUEST_ATTRIBUTE_SUCCESS = 'FETCH_REQUEST_ATTRIBUTE_SUCCESS';
export const FETCH_REQUEST_ATTRIBUTE_FAIL = 'FETCH_REQUEST_ATTRIBUTE_FAIL';

export const FETCH_EMPLOYEE_WORK_SHEET_START = 'FETCH_EMPLOYEE_WORK_SHEET_START';
export const FETCH_EMPLOYEE_WORK_SHEET_SUCCESS = 'FETCH_EMPLOYEE_WORK_SHEET_SUCCESS';
export const FETCH_EMPLOYEE_WORK_SHEET_FAIL = 'FETCH_EMPLOYEE_WORK_SHEET_FAIL';

export const FETCH_EMPLOYEE_DIVISION_START = 'FETCH_EMPLOYEE_DIVISION_START';
export const FETCH_EMPLOYEE_DIVISION_SUCCESS = 'FETCH_EMPLOYEE_DIVISION_SUCCESS';
export const FETCH_EMPLOYEE_DIVISION_FAIL = 'FETCH_EMPLOYEE_DIVISION_FAIL';

export const ROLE_SUCCESS = 'ROLE_SUCCESS';
export const ROLE_START = 'ROLE_START';
export const ROLE_FAIL = 'ROLE_FAIL';

export const FETCH_TIME_OFF_START = 'FETCH_TIME_OFF_START';
export const FETCH_TIME_OFF_SUCCESS = 'FETCH_TIME_OFF_SUCCESS';
export const FETCH_TIME_OFF_FAIL = 'FETCH_TIME_OFF_FAIL';

export const FETCH_APPLICANT_START = 'FETCH_APPLICANT_START';
export const FETCH_APPLICANT_SUCCESS = 'FETCH_APPLICANT_SUCCESS';
export const FETCH_APPLICANT_FAIL = 'FETCH_APPLICANT_FAIL';

export const FETCH_REQUESTLISTGEN_START = 'FETCH_REQUESTLISTGEN_START';
export const FETCH_REQUESTLISTGEN_SUCCESS = 'FETCH_REQUESTLISTGEN_SUCCESS';
export const FETCH_REQUESTLISTGEN_FAIL = 'FETCH_REQUESTLISTGEN_FAIL';

export const FETCH_DEPENDANT_START = 'FETCH_DEPENDANT_START';
export const FETCH_DEPENDANT_SUCCESS = 'FETCH_DEPENDANT_SUCCESS';
export const FETCH_DEPENDANT_FAIL = 'FETCH_DEPENDANT_FAIL';

export const FETCH_ITSMINCIDENT_START = 'FETCH_ITSMINCIDENT_START';
export const FETCH_ITSMINCIDENT_SUCCESS = 'FETCH_ITSMINCIDENT_SUCCESS';
export const FETCH_ITSMINCIDENT_FAIL = 'FETCH_ITSMINCIDENTFAIL';

export const POSITION_CHART_START = 'POSITION_CHART_START';
export const POSITION_CHART_SUCCESS = 'POSITION_CHART_SUCCESS';
export const POSITION_CHART_FAIL= 'POSITION_CHART_FAIL';

export const GET_POSITIONHIERARCHY_GRAPH_START = 'GET_POSITIONHIERARCHY_GRAPH_START';
export const GET_POSITIONHIERARCHY_GRAPH_SUCCESS = 'GET_POSITIONHIERARCHY_GRAPH_SUCCESS';
export const GET_POSITIONHIERARCHY_GRAPH_FAIL= 'GET_POSITIONHIERARCHY_GRAPH_FAIL';

export const FETCH_GET_HRANALYTICS_START = 'FETCH_GET_HRANALYTICS_START';
export const FETCH_GET_HRANALYTICS_SUCCESS = 'FETCH_GET_HRANALYTICS_SUCCESS';
export const FETCH_GET_HRANALYTICS_FAIL= 'FETCH_GET_HRANALYTICS_FAIL';

export const FETCH_GET_GRAPHDATA_START = 'FETCH_GET_GRAPHDATA_START';
export const FETCH_GET_GRAPHDATA_SUCCESS = 'FETCH_GET_GRAPHDATA_SUCCESS';
export const FETCH_GET_GRAPHDATA_FAIL= 'FETCH_GET_GRAPHDATA_FAIL';

export const SET_SELECTED_MODULE = 'SET_SELECTED_MODULE';


export const CLEAR_CACHE = 'CLEAR_CACHE';


export const MASTER_DATA_START = 'MASTER_DATA_START';
export const MASTER_DATA_SUCCESS = 'MASTER_DATA_SUCCESS';
export const MASTER_DATA_FAIL = 'MASTER_DATA_FAIL';

export const SET_SELECTED_BRANCH = 'SET_SELECTED_BRANCH';